import React from "react";
import Images from "../images";
import "./LeaderboardBracket.css";

const DEFAULT_CONNECTIONS = [
  { from: "winner", to: "semi-left", midY: 18 },
  { from: "winner", to: "semi-right", midY: 18 },
  { from: "semi-left", to: "q1", midY: 35 },
  { from: "semi-left", to: "q2", midY: 35 },
  { from: "semi-right", to: "q3", midY: 35 },
  { from: "semi-right", to: "q4", midY: 35 },
  { from: "q2", to: "r1", midY: 53 },
  { from: "q2", to: "r2", midY: 53 },
  { from: "q3", to: "r3", midY: 53 },
  { from: "q3", to: "r4", midY: 53 },
  { from: "q1", to: "b1", midY: 74 },
  { from: "q1", to: "b2", midY: 74 },
  { from: "q4", to: "b3", midY: 74 },
  { from: "q4", to: "b4", midY: 74 }
];

const AVATAR_TOP_OFFSET = 2.35;
const AVATAR_BOTTOM_OFFSET = 1.55;

const clampPercent = value => {
  const parsedValue = parseFloat(value);
  if (Number.isNaN(parsedValue)) {
    return 0;
  }
  return Math.max(0, Math.min(100, parsedValue));
};

const getPlayerMap = players => {
  return (players || []).reduce((map, player) => {
    if (player && player.id) {
      map[player.id] = {
        ...player,
        x: clampPercent(player.x),
        y: clampPercent(player.y)
      };
    }
    return map;
  }, {});
};

const getPoint = (player, edge = "center") => {
  if (edge === "top") {
    return {
      x: player.x,
      y: clampPercent(player.y - AVATAR_TOP_OFFSET)
    };
  }

  if (edge === "bottom") {
    return {
      x: player.x,
      y: clampPercent(player.y + AVATAR_BOTTOM_OFFSET)
    };
  }

  return {
    x: player.x,
    y: player.y
  };
};

const getElbowPath = (startPlayer, endPlayer, midLineY) => {
  const start = getPoint(startPlayer, "bottom");
  const end = getPoint(endPlayer, "top");
  const midY = typeof midLineY === "number" ? midLineY : start.y + (end.y - start.y) / 2;
  return `M ${start.x} ${start.y} V ${midY} H ${end.x} V ${end.y}`;
};

const LeaderboardBracket = ({ players = [], onPlayerClick, className = "" }) => {
  const playerMap = getPlayerMap(players);

  return (
    <div className={`leaderboard-bracket ${className}`}>
      <svg
        className="leaderboard-bracket-lines"
        viewBox="0 0 100 100"
        preserveAspectRatio="none"
        aria-hidden="true"
      >
        {DEFAULT_CONNECTIONS.map(connection => {
          const startId = connection.from;
          const endId = connection.to;
          const start = playerMap[startId];
          const end = playerMap[endId];

          if (!start || !end) {
            return null;
          }

          return (
            <path
              key={`${startId}-${endId}`}
              d={getElbowPath(start, end, connection.midY)}
              fill="none"
              vectorEffect="non-scaling-stroke"
            />
          );
        })}
      </svg>

      <div className="leaderboard-bracket-center" aria-hidden="true">
        <img
          src={Images.LOGO_NEW}
          alt=""
        />
      </div>

      {(players || []).map(player => {
        const isEmpty = player.status === "empty";
        const isDisabled = player.status === "disabled" || isEmpty;
        const avatarSrc = player.avatar || Images.DEFAULT_USER;

        return (
          <button
            type="button"
            key={player.id}
            className={`leaderboard-bracket-player ${player.status || ""}`}
            style={{
              left: `${clampPercent(player.x)}%`,
              top: `${clampPercent(player.y)}%`
            }}
            onClick={() => {
              if (!isDisabled && onPlayerClick) {
                onPlayerClick(player);
              }
            }}
            disabled={isDisabled}
            title={player.name || "TBD"}
          >
            <span className="leaderboard-bracket-avatar">
              <img
                src={avatarSrc}
                alt={player.name || "Player"}
                onError={event => {
                  event.currentTarget.src = Images.DEFAULT_USER;
                }}
              />
            </span>
            <span className="leaderboard-bracket-name">{player.name || "TBD"}</span>
          </button>
        );
      })}
    </div>
  );
};

export default LeaderboardBracket;
